import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'reactstrap';
import NumberInput from '../../common/controls/numberInput';
const OrganizationCoatingInput = _ref => {
  let _ref$coatingScoreDivi = _ref.coatingScoreDivisions,
    coatingScoreDivisions = _ref$coatingScoreDivi === void 0 ? [] : _ref$coatingScoreDivi,
    labelText = _ref.labelText,
    index = _ref.index,
    onChange = _ref.onChange;
  // Ensure that the coatingScoreDivision exists at that index before
  // applying, or return ''
  const value = coatingScoreDivisions && coatingScoreDivisions.length ? coatingScoreDivisions[index].cost : '';
  const handleChange = newValue => {
    onChange("coatingScoreDivisions[".concat(index, "]/cost"), newValue);
  };
  return /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(NumberInput, {
    label: labelText,
    value: value,
    entity: "CoatingScoreDivision",
    field: "cost".concat(index),
    onChange: handleChange
  }));
};
OrganizationCoatingInput.propTypes = {
  coatingScoreDivisions: PropTypes.arrayOf(PropTypes.shape({
    cost: PropTypes.number
  })),
  index: PropTypes.number.isRequired,
  labelText: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};
export default OrganizationCoatingInput;